import { Tooltip } from '@mui/material'
import {
    Modal,
    ModalBody,
    ModalContent,
    useDisclosure,
} from '@nextui-org/react'
import cn from 'classnames'
import React, { useState } from 'react'
import LazyLoad from 'react-lazy-load'

import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import { MarketCard } from '../card/MarketCard'
import Link2 from '../common/util/input/Link2'
import { useSharedState } from '../waxplorer/Waxplorer'
import { AssetDetailsPopupContent } from './AssetDetailsPopupContent'
import { CollectionAssetName } from './CollectionAssetName'
import { MarketAssetPreviewInfo } from './MarketAssetPreviewInfo'
import { useTheme } from 'next-themes'
import { useToast } from '../ui/use-toast'
import { showErrorToast, showSuccessToast } from '../../utils/toasts'
import { ModalActions } from './ModalActions'
import BuyofferButtons from '../marketbuttons/BuyofferButtons'

// @ts-ignore
const BuyofferAssetPreview = ({
    buyoffer,
    onAdd,
    bundleView,
    page,
    showOwner,
    searchOwner,
    clickAsset,
    index,
    assetType,
    previewDuration = 2,
}) => {
    const [state, dispatch] = useSharedState()
    const { theme } = useTheme()
    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null
    const [newOwner, setNewOwner] = useState(null)
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [canceled, setCanceled] = useState(false)
    const [transferred, setTransferred] = useState(false)
    const [action, setAction] = useState(null)

    const { buyofferId, collection, template } = buyoffer

    const handleCallBack = (info, action) => {
        if (info) {
            if (info['success']) {
                if (action === 'accept_buyoffer') {
                    setTransferred(true)
                } else if (action === 'cancel') {
                    setNewOwner(userName)
                    buyoffer['owner'] = userName
                    setCanceled(true)
                } else if (action === 'claim') {
                    setTransferred(true)
                }
            }
        }

        setIsLoading(false)
    }

    const cardHeader = (
        <div className={'absolute w-full h-8 z-10'}>
            <div className={'absolute flex m-auto h-10 w-8'}></div>
            <div />
            <div />
        </div>
    )

    const href = '/buyoffer/' + buyofferId

    const { isOpen, onOpen, onOpenChange } = useDisclosure()

    const { toast } = useToast()

    const callBack = (info, localAction = null) => {
        if (info?.success) {
            if (info?.transactionId) {
                showSuccessToast(
                    toast,
                    <Link2
                        external={true}
                        href={
                            'https://waxblock.io/transaction/' +
                            info.transactionId
                        }
                    >
                        <div className={'text-xs font-medium'}>
                            {info.transactionId.substr(0, 32) + '...'}
                        </div>
                    </Link2>,
                )
            }
        }
        if (info?.error) {
            showErrorToast(toast, info.error)
        }

        handleCallBack(info, localAction ? localAction : action)

        setAction(null)
    }

    const buyofferButtons = (view) => (
        <BuyofferButtons
            view={view}
            className={'-mt-4 h-full w-full md1:w-[380px] '}
            onAdd={onAdd}
            buyoffer={buyoffer}
            newOwner={newOwner}
            searchOwner={searchOwner}
            callBack={callBack}
            assetType={assetType}
            page={page}
            canceled={canceled}
            transferred={transferred}
            error={error}
            setError={setError}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            showOwner={showOwner}
            setAction={setAction}
            action={action}
            onOpen={onOpen}
        />
    )

    return (
        <LazyLoad offset={200}>
            <div>
                <MarketCard height={'high'} cardHeader={cardHeader} page={page}>
                    <ModalActions
                        action={action}
                        asset={buyoffer}
                        callBack={callBack}
                    />
                    <div
                        className={
                            ' relative flex  justify-center items-center  !aspect-1 '
                        }
                    >
                        <div
                            className={cn(
                                'flex justify-center items-center w-full h-full',
                            )}
                        >
                            <Link2
                                inactive={
                                    page === 'newbuyoffer' ||
                                    page === 'editor' ||
                                    clickAsset
                                }
                                href={href}
                                onClick={(e) => {
                                    const elem = window.document.getElementById(
                                        'AssetDetailsPopupContent' +
                                            template?.templateId,
                                    )
                                    if (!elem || !elem.contains(e.target)) {
                                        dispatch({
                                            type: 'SET_ACTION_SEARCH',
                                            payload: {
                                                actionSearch: '',
                                                asset: null,
                                                searchType: '',
                                                searchID: '',
                                                includeDrops: false,
                                            },
                                        })
                                    }
                                }}
                                altOnClick={
                                    clickAsset
                                        ? () => clickAsset(index)
                                        : () => {}
                                }
                                className={cn('h-full w-full ')}
                            >
                                <div
                                    className={cn(
                                        'text-center cursor-pointer h-full w-full',
                                    )}
                                >
                                    <Tooltip
                                        leaveDelay={100}
                                        title={
                                            <AssetDetailsPopupContent
                                                asset={buyoffer}
                                                listing={buyoffer}
                                                userName={userName}
                                            />
                                        }
                                        placement="right"
                                        arrow
                                        enterDelay={700}
                                        enterNextDelay={700}
                                        disableTouchListener
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    borderRadius: '1rem',
                                                    backgroundColor:
                                                        theme === 'light'
                                                            ? 'white'
                                                            : '#141414FA',
                                                    maxWidth: 'none',
                                                },
                                            },
                                        }}
                                    >
                                        <div className="w-full h-full overflow-hidden">
                                            <AssetPreviewDisplay
                                                asset={template}
                                                previewDuration={
                                                    previewDuration
                                                }
                                                className={cn('h-full')}
                                                imgClassName={cn(
                                                    'object-contain transition transform h-full w-full',
                                                    'duration-500 md:hover:scale-100 hover:scale-105  cursor-pointer',
                                                )}
                                            />
                                        </div>
                                    </Tooltip>
                                </div>
                            </Link2>
                        </div>
                    </div>
                    <div
                        className={'p-4 flex flex-wrap h-full justify-between'}
                    >
                        <CollectionAssetName
                            linkInactive={
                                page === 'newbuyoffer' ||
                                page === 'editor' ||
                                clickAsset
                            }
                            onClick={() => {
                                dispatch({
                                    type: 'SET_ACTION_SEARCH',
                                    payload: {
                                        actionSearch: '',
                                        asset: null,
                                        searchType: '',
                                        searchID: '',
                                        includeDrops: false,
                                    },
                                })
                            }}
                            altOnClick={
                                clickAsset ? () => clickAsset(index) : () => {}
                            }
                            href={href}
                            collection={collection}
                            name={
                                template?.name
                                    ? template.name
                                    : template?.templateId
                            }
                        />

                        {buyofferButtons()}
                    </div>
                </MarketCard>

                <Modal
                    size={'5xl'}
                    isOpen={isOpen}
                    onOpenChange={onOpenChange}
                    scrollBehavior={'inside'}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                    classNames={{
                        body: 'p-0',
                        closeButton:
                            'absolute top-2 right-2 z-50 bg-red-500 text-white hover:bg-red-600',
                    }}
                >
                    <ModalContent>
                        <ModalBody className="w-full px-0 py-0 ">
                            <MarketAssetPreviewInfo
                                asset={template}
                                listing={buyoffer}
                                newOwner={newOwner}
                                bundleView={bundleView}
                                show={onOpen}
                                buttons={buyofferButtons('full')}
                            />
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </LazyLoad>
    )
}

function assetPropsAreEqual(prevAsset, nextAsset) {
    const id1 = prevAsset.auctionId
    const id2 = nextAsset.auctionId

    return id1 === id2 && prevAsset.index === nextAsset.index
}

export default React.memo(BuyofferAssetPreview, assetPropsAreEqual)
